// EXPLICIT "this top-up was started from the booking form" marker.
//
// Why this exists (2026-07-19):
// booking drafts live in localStorage for 24h, so a half-filled booking a
// client abandoned yesterday is still sitting there today. The paypage return
// handler used to offer "continue my booking request" for ANY paid checkout
// that wasn't itself a booking, as long as a draft happened to exist — so
// paying an invoice, a price adjustment, or topping up from the Wallet page
// would all resurface a stale, unrelated booking draft.
//
// The fix: only a wallet top-up that was LAUNCHED FROM the booking request /
// edit page sets this marker. The return handler offers to resume the draft
// only when (a) the payment was a genuine wallet top-up AND (b) this marker is
// present. Everything else — invoices, adjustments, failed-charge repayments,
// wallet-page top-ups — never touches a booking draft.
//
// Same 24h TTL as the drafts themselves, so a marker can't outlive its draft.

const KEY = 'hhc_topup_booking_intent';
const TTL_MS = 24 * 60 * 60 * 1000;

/** Record that the top-up about to happen came from the booking form. */
export function setTopupBookingIntent(kind /* 'create' | 'edit' */) {
    try {
        localStorage.setItem(KEY, JSON.stringify({
            kind: kind === 'edit' ? 'edit' : 'create',
            at: Date.now(),
        }));
    } catch { /* storage unavailable — the flow still works, just no resume offer */ }
}

/** 'create' | 'edit' when a live (<24h) booking top-up intent exists, else null. */
export function getTopupBookingIntent() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const v = JSON.parse(raw);
        if (!v || typeof v.at !== 'number' || Date.now() - v.at > TTL_MS) {
            localStorage.removeItem(KEY);
            return null;
        }
        return v.kind === 'edit' ? 'edit' : 'create';
    } catch {
        return null;
    }
}

export function clearTopupBookingIntent() {
    try { localStorage.removeItem(KEY); } catch { /* nothing to clear */ }
}
